
import { SchoolGiveWidget } from './SchoolGiveWidget.js';

/**
 * A give widget and (optionally) some project-results for a specific school. Shown when the user specifies a school in
 * search.
 *
 * TODO rename?
 *
 * SLG2TODO If it's easy to do, it'd probably be nicer to not show the give widget until the search finishes loading.
 */
export const SchoolRelatedSection = ({ schoolId, schoolName, projectList }) => {
    return (
        <div className="school-give">
            <h3 className="school-name">{schoolName}</h3>
            <SchoolGiveWidget schoolId={schoolId} schoolName={schoolName} key={0} useAjax={false} />
            {projectList}
        </div>
    );
};
